export const CommercialPermissions = {
  "Asst. General Manager": [
    {
      path: "/commercial/proformas",
      label: "Pro. Invoices",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/commercial/lcs",
      label: "LC",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/purchase-contracts",
      label: "PC/JOBS",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/commercial/hscodes",
      label: "HS CODE",
      icon: "fas fa-chevron-right me-1",
    },
  ],
  Manager: [
    {
      path: "/commercial/proformas",
      label: "Pro. Invoices",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/commercial/lcs",
      label: "LC",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/purchase-contracts",
      label: "PC/JOBS",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/commercial/hscodes",
      label: "HS CODE",
      icon: "fas fa-chevron-right me-1",
    },
  ],
  "Assistant Manager": [
    {
      path: "/commercial/proformas",
      label: "Pro. Invoices",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/commercial/lcs",
      label: "LC",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/purchase-contracts",
      label: "PC/JOBS",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/commercial/hscodes",
      label: "HS CODE",
      icon: "fas fa-chevron-right me-1",
    },
  ],
  Executive: [
    {
      path: "/commercial/proformas",
      label: "Pro. Invoices",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/commercial/lcs",
      label: "LC",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/purchase-contracts",
      label: "PC/JOBS",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/commercial/hscodes",
      label: "HS CODE",
      icon: "fas fa-chevron-right me-1",
    },
  ],
  "Jr. Executive": [
    {
      path: "/commercial/proformas",
      label: "Pro. Invoices",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/commercial/lcs",
      label: "LC",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/purchase-contracts",
      label: "PC/JOBS",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/commercial/hscodes",
      label: "HS CODE",
      icon: "fas fa-chevron-right me-1",
    },
  ],
  "Sr. Executive": [
    {
      path: "/commercial/proformas",
      label: "Pro. Invoices",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/commercial/lcs",
      label: "LC",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/merchandising/purchase-contracts",
      label: "PC/JOBS",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/commercial/hscodes",
      label: "HS CODE",
      icon: "fas fa-chevron-right me-1",
    },
  ],
};
